import { StyleSheet } from 'aphrodite';
import { destructive, header } from '../../styles/colors';
import { shadowSm } from '../../styles/shadows';
import { THEME } from '../Theme/theme';

export const s = StyleSheet.create({
	checkbox: {
		border: `1px solid ${header}`,
		width: 14,
		height: 14,
		flexShrink: 0,
		borderRadius: 2,
		boxShadow: shadowSm,
		transition: 'color, box-shadow',
		outline: 'none',
		':disabled': {
			cursor: 'not-allowed',
			opacity: 0.5,
		},
		':is([data-state="checked"])': {
			color: THEME.colors.primary.main,
		},
		':is([data-state="indeterminate"])': {
			color: THEME.colors.primary.main,
		},
		':focus-visible': {
			borderColor: THEME.colors.primary.main,
		},
		':is([aria-invalid="true"])': {
			borderColor: destructive,
		},
	},
	md: {
		width: 14,
		height: 14,
		':has(*) svg': {
			width: 12,
			height: 12,
		},
	},
	lg: {
		width: 16,
		height: 16,
		':has(*) svg': {
			width: 14,
			height: 14,
		},
	},
	indicator: {
		display: 'grid',
		placeContent: 'center',
		color: 'currentColor',
		transition: 'none',
		'--check-indicator-display': 'block',
		'--minus-indicator-display': 'none',
		':is([data-state="indeterminate"])': {
			'--check-indicator-display': 'none',
			'--minus-indicator-display': 'block',
		},
	},
	indicatorIcon: {
		width: 12,
		height: 12,
		// @ts-ignore
		display: 'var(--check-indicator-display)',
	},
	indeterminateIcon: {
		// @ts-ignore
		display: 'var(--minus-indicator-display)',
	},
});
